import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 4,
  class: "flex items-center gap-3"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_ctx.column.key === 'invoiceNumber')
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_ctx.row.invoice)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: `/invoice/${_ctx.row.invoice.id}`,
              target: "_blank",
              class: "text-blue-500"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.row[_ctx.column.key]), 1)
              ]),
              _: 1
            }, 8, ["to"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.row[_ctx.column.key]), 1)
            ], 64))
      ], 64))
    : (_ctx.column.key === 'waitListCreateDate')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.row[_ctx.column.key])), 1)
        ], 64))
      : (_ctx.column.key === 'clientResponseDate')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.row[_ctx.column.key])), 1)
          ], 64))
        : (_ctx.column.key === 'processingStatus')
          ? (_openBlock(), _createBlock(_component_cheap, {
              key: 3,
              class: _normalizeClass(["small", {
                yellow: _ctx.row.processingStatus.id === 47,
                green: _ctx.row.processingStatus.id === 48,
                red: _ctx.row.processingStatus.id === 49,
                'green--outline': _ctx.row.processingStatus.id === 71,
                'yellow--outline': _ctx.row.processingStatus.id === 72,
            }])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.row.processingStatus.name), 1)
              ]),
              _: 1
            }, 8, ["class"]))
          : (_ctx.column.key === 'actions')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_the_button, {
                  class: "yellow small",
                  hint: "Редактировать",
                  onClick: _ctx.onUpdateTask
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_the_button, {
                  class: "primary small",
                  hint: "Отправить на звонок",
                  loading: _ctx.is_send_to_call_loading,
                  onClick: _ctx.onSendToCall
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"])
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                _createTextVNode(_toDisplayString(_ctx.row[_ctx.column.key] || '-'), 1)
              ], 64))
}